import { useTranslation } from 'react-i18next';
import { formatNameWithCode } from '~/utils';
import {
  NO_PRODUCTS,
  type OrderCardProduct,
  type OrderCardPlant,
} from '~/pages/orders/lib/orderCardProducts';

const MAX_PRODUCT_CHIPS = 3;

type OrderCardDetailsProps = {
  readonly products?: OrderCardProduct[];
  readonly plant?: OrderCardPlant | null;
  readonly deliveryLocation?: string | null;
};

export function OrderCardDetails({
  products = NO_PRODUCTS,
  plant,
  deliveryLocation,
}: OrderCardDetailsProps) {
  const { t } = useTranslation('order');

  return (
    <>
      {products.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mb-3">
          {products.slice(0, MAX_PRODUCT_CHIPS).map((product) => {
            const label = formatNameWithCode(product.name, product.code);
            return (
              <span
                key={label}
                data-testid="order-product-chip"
                className="rounded-full bg-neut-100 px-2 py-0.5 text-xs text-neut-700"
              >
                {label}
              </span>
            );
          })}
          {products.length > MAX_PRODUCT_CHIPS && (
            <span
              data-testid="order-product-overflow"
              className="rounded-full bg-neut-100 px-2 py-0.5 text-xs text-neut-500"
            >
              {t('order.more_products', {
                count: products.length - MAX_PRODUCT_CHIPS,
              })}
            </span>
          )}
        </div>
      )}
      {plant && (
        <div data-testid="order-plant" className="text-sm text-neut-600">
          {t('order.plant')}: {formatNameWithCode(plant.name, plant.code)}
        </div>
      )}
      {deliveryLocation && (
        <div data-testid="order-destination" className="text-sm text-neut-600">
          {t('order.final_delivery')}: {deliveryLocation}
        </div>
      )}
    </>
  );
}
